import { render } from "./TablaPrestados.vue?vue&type=template&id=26453366&ts=true"
import script from "./TablaPrestados.vue?vue&type=script&lang=ts"
export * from "./TablaPrestados.vue?vue&type=script&lang=ts"

import "./TablaPrestados.vue?vue&type=style&index=0&id=26453366&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__